export default __webpack_public_path__ + "static/media/IconPassword.a35cced7.svg";